__turbopack_export_value__({
  "body-logo-18": "ErrorPage-module-scss-module__5cztfG__body-logo-18",
  "body-text-12": "ErrorPage-module-scss-module__5cztfG__body-text-12",
  "body-text-14": "ErrorPage-module-scss-module__5cztfG__body-text-14",
  "body-text-16": "ErrorPage-module-scss-module__5cztfG__body-text-16",
  "body-text-18": "ErrorPage-module-scss-module__5cztfG__body-text-18",
  "body-text-20": "ErrorPage-module-scss-module__5cztfG__body-text-20",
  "body-text-24": "ErrorPage-module-scss-module__5cztfG__body-text-24",
  "body-text-24-2": "ErrorPage-module-scss-module__5cztfG__body-text-24-2",
  "body-text-heading-2": "ErrorPage-module-scss-module__5cztfG__body-text-heading-2",
  "body-text-heading-3": "ErrorPage-module-scss-module__5cztfG__body-text-heading-3",
  "body-text-medium-14": "ErrorPage-module-scss-module__5cztfG__body-text-medium-14",
  "body-text-medium-16": "ErrorPage-module-scss-module__5cztfG__body-text-medium-16",
  "body-text-medium-18": "ErrorPage-module-scss-module__5cztfG__body-text-medium-18",
  "body-text-medium2-18": "ErrorPage-module-scss-module__5cztfG__body-text-medium2-18",
  "body-text2-14": "ErrorPage-module-scss-module__5cztfG__body-text2-14",
  "body-text2-16": "ErrorPage-module-scss-module__5cztfG__body-text2-16",
  "button-primary-text": "ErrorPage-module-scss-module__5cztfG__button-primary-text",
  "button-text": "ErrorPage-module-scss-module__5cztfG__button-text",
  "button2-text": "ErrorPage-module-scss-module__5cztfG__button2-text",
  "card-shadow": "ErrorPage-module-scss-module__5cztfG__card-shadow",
  "effect-menu": "ErrorPage-module-scss-module__5cztfG__effect-menu",
  "error": "ErrorPage-module-scss-module__5cztfG__error",
  "error__container": "ErrorPage-module-scss-module__5cztfG__error__container",
  "error__nginx": "ErrorPage-module-scss-module__5cztfG__error__nginx",
  "error__svg": "ErrorPage-module-scss-module__5cztfG__error__svg",
  "error__text": "ErrorPage-module-scss-module__5cztfG__error__text",
  "header-1": "ErrorPage-module-scss-module__5cztfG__header-1",
  "main-container": "ErrorPage-module-scss-module__5cztfG__main-container",
  "main-footer-container": "ErrorPage-module-scss-module__5cztfG__main-footer-container",
  "main-header-container": "ErrorPage-module-scss-module__5cztfG__main-header-container",
  "txt-12-bold": "ErrorPage-module-scss-module__5cztfG__txt-12-bold",
  "txt-14-bold": "ErrorPage-module-scss-module__5cztfG__txt-14-bold",
  "txt-14-bold-caps": "ErrorPage-module-scss-module__5cztfG__txt-14-bold-caps",
  "txt-14-med": "ErrorPage-module-scss-module__5cztfG__txt-14-med",
  "txt-16-bold": "ErrorPage-module-scss-module__5cztfG__txt-16-bold",
  "txt-16-med": "ErrorPage-module-scss-module__5cztfG__txt-16-med",
  "txt-18-bold": "ErrorPage-module-scss-module__5cztfG__txt-18-bold",
  "txt-18-medium": "ErrorPage-module-scss-module__5cztfG__txt-18-medium",
  "txt-18-medium-24": "ErrorPage-module-scss-module__5cztfG__txt-18-medium-24",
  "txt-24-semi": "ErrorPage-module-scss-module__5cztfG__txt-24-semi",
});
